export const SET_CURRENT_NET_INFO = 'SET_CURRENT_NET_INFO';

export default function setCurrentNetInfo(payload) {
  return {
    type: SET_CURRENT_NET_INFO,
    payload,
  };
}
